export enum GiftCategoryStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum GiftItemType {
    PRODUCT = 'PRODUCT',
    CASH = 'CASH'
}

export enum GiftItemStatus {
    ON_SALE = 'ON_SALE',
    SOLD_OUT = 'SOLD_OUT',
    DISCONTINUED = 'DISCONTINUED',
}

export enum GiftBoxType {
    SENT = 'SENT',
    RECEIVED = 'RECEIVED'
}

export enum GiftBoxStatus {
    USED = 'USED',
    EXPIRED = 'EXPIRED',
    PENDING = 'PENDING',
    CANCELED = 'CANCELED',
}

export enum GiftCouponStatus {
    ISSUED = 'ISSUED',
    CANCELED = 'CANCELED',
    USED = 'USED',
    OFF_USED = 'OFF_USED',
    CANCEL_FAILED = 'CANCEL_FAILED',
    EXPIRED = 'EXPIRED',
    DEACTIVATED = 'DEACTIVATED',
    SENT = 'SENT',
    SEND_FAILED = 'SEND_FAILED',
}

export enum GiftPaymentMethod {
    CREDIT_CARD = 'CREDIT_CARD',
    PREPAID_CARD = 'PREPAID_CARD',
}
